export default __webpack_public_path__ + "static/media/weezpay-logo.db867f84.png";